import React from 'react'
import {connect} from 'react-redux'
import {List} from 'immutable'

import {
  CONVERSATION_TYPES
} from '../shared/config/constants'

import ChatListSegment from './chat_list_segment'

class ChatListUserSegment extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      page: 1
    }

    this.loadNextUserBatch = this.loadNextUserBatch.bind(this)
  }

  componentWillMount () {
    const {users, guests} = this.props
    const {page} = this.state

    if (users || guests) {
      this.setVisibleUsers(users, guests, page)
    }
  }

  componentWillReceiveProps (nextProps, nextState) {
    const {users, guests} = this.props
    const {users: nextUsers, guests: nextGuests} = nextProps
    const {page} = this.state
    const {page: nextPage} = nextState

    if (users !== nextUsers || guests !== nextGuests || page !== nextPage) {
      this.setVisibleUsers(nextUsers, nextGuests, nextPage)
    }
  }

  setVisibleUsers (users, guests, page = 1) {
    users = users.concat(guests).take(page * 20)

    this.setState({users})
  }

  loadNextUserBatch (e) {
    if (e && e.preventDefault) e.preventDefault()

    const page = this.state.page + 1

    this.setState({page})
    this.setVisibleUsers(this.props.users, this.props.guests, page)
  }

  renderUserFooter () {
    const totalSize = this.props.users.size + this.props.guests.size

    if (totalSize > this.state.page * 20) {
      return (
        <a
          href='#'
          className='chat-list-footer-action'
          onClick={this.loadNextUserBatch}>
          LOAD MORE USERS
        </a>
      )
    }
  }

  render () {
    return (
      <ChatListSegment
        label={this.props.title}
        emptyMessage='There are no online users at the moment.'
        footer={this.renderUserFooter()}
        conversationType={CONVERSATION_TYPES.MIXED}
        shouldShowUnreadMessageCount={false}
        list={this.state.users}/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    title: state.getIn(['chatSettings', 'segments', 'users', 'title']),
    users: state.getIn(['chatListView', 'segments', 'users'], List()),
    guests: state.getIn(['chatListView', 'segments', 'guests'], List())
  }
}

const ChatListUserSegmentContainer = connect(
  mapStateToProps
)(ChatListUserSegment)

export default ChatListUserSegmentContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list_user_segment.js
 **/